import * as z from 'zod'
import { CheckInRewardType } from '@/schema'
import { walletConditionSchema } from '@/common/components/WalletConditionSection'

export const MIN_DAILY_CHECK_IN_DAYS = 1
export const MAX_DAILY_CHECK_IN_DAYS = 25

const checkInSettingSchema = z
	.object({
		day: z.number().min(1, 'วันที่ต้องมากกว่าหรือเท่ากับ 1'),
		rewardType: z.nativeEnum(CheckInRewardType),
		amount: z.number().min(0, 'จำนวนรางวัลต้องมากกว่าหรือเท่ากับ 0'),
		minimumTurnoverAmount: z
			.number()
			.min(0, 'ยอดเทิร์นขั้นต่ำต้องมากกว่าหรือเท่ากับ 0')
			.optional()
			.nullable(),
		minimumDepositAmount: z
			.number()
			.min(0, 'ยอดฝากขั้นต่ำต้องมากกว่าหรือเท่ากับ 0')
			.optional()
			.nullable(),
		// FREE_SPIN specific fields
		presetId: z.string().optional(),
		gameId: z.string().optional(),
		betAmount: z.number().optional(),
	})
	.refine(
		(data) => {
			if (data.rewardType === CheckInRewardType.FREE_SPIN) {
				return !!data.presetId && !!data.gameId && !!data.betAmount
			}
			return true
		},
		{
			message: 'กรุณากรอกข้อมูล Preset, เกม และจำนวนเดิมพันสำหรับฟรีสปิน',
			path: ['presetId'],
		},
	)

export const dailyCheckInFormSchema = z.object({
	name: z.string().min(1, 'กรุณากรอกชื่อโปรโมชั่น'),
	isActive: z.boolean(),
	requireConnectedLine: z.boolean(),
	days: z
		.number()
		.min(
			MIN_DAILY_CHECK_IN_DAYS,
			`จำนวนวันต้องมากกว่าหรือเท่ากับ ${MIN_DAILY_CHECK_IN_DAYS}`,
		)
		.max(
			MAX_DAILY_CHECK_IN_DAYS,
			`จำนวนวันต้องน้อยกว่าหรือเท่ากับ ${MAX_DAILY_CHECK_IN_DAYS}`,
		),
	checkInSetting: z.array(checkInSettingSchema),
	walletCondition: walletConditionSchema.optional(),
})

export type DailyCheckInFormValues = z.infer<typeof dailyCheckInFormSchema>
